/**
 * Dashboard API Service
 * Gọi API để lấy dữ liệu dashboard và báo cáo trong ngày
 */

import { ApiResponse, fetchWithAuth } from '../utils/api';
import { getDashboardEndpoints } from '../config/api';

export interface DashboardStats {
  totalLeads: number;
  totalMarketers: number;
  totalRevenue: number;
  todayLeads: number;
  todayRevenue: number;
}

/**
 * Lấy báo cáo dashboard trong ngày
 * @param date Optional - Ngày cần lấy báo cáo (format: YYYY-MM-DD), mặc định là hôm nay
 */
export const getDashboardReport = async (
  date?: string
): Promise<DashboardStats | null> => {
  try {
    const endpoint = getDashboardEndpoints().DAILY_REPORT;

    const response = await fetchWithAuth<ApiResponse<DashboardStats>>(endpoint);

    if (response.success && response.data?.data) {
      return response.data.data;
    }
    return null;
  } catch (error) {
    console.error('Error fetching dashboard report:', error);
    return null;
  }
};

export default {
  getDashboardReport,
};
